import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';

import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import moment from 'moment';

import {DABBL_PUBLISHER_ID} from '../../../config';

class AccountTransferHistory extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for AccountTransferHistory in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after AccountTransferHistory in componentWillUnmount
  }

  renderEventCell(item){
    if(item.fromAccountId === DABBL_PUBLISHER_ID){
      if(item.kind === 'invoice'){
        return (<strong>Funds Added (Invoice)</strong>)
      } else if(item.kind === 'card'){
        return (<strong>Funds Added (Self Serve)</strong>)
      } else if(item.kind === 'adjoy'){
        return (<strong>Funds Added (Dabbl Pays)</strong>)
      }
    } else if(item.fromAccountId === this.props.accountId){
      return (<strong>Experience Launched</strong>)
    } else if(item.toAccountId === this.props.accountId){
      return (<strong>Funds Added (Experience)</strong>)
    } else {
      return (<strong>Other</strong>)
    }
  }

  renderDescriptionCell(item){
    console.log('ITEM ',item);
    if(item.io && item.io.length > 0 && item.fromAccountId === DABBL_PUBLISHER_ID){
      return (<span>{item.io}</span>)
    } else if(item.io){
      return (<span>{item.io}</span>)
    } else if(item.fromAccountId === this.props.accountId){
      return (<span>Experience: {item.toName}</span>)
    } else if(item.toAccountId === this.props.accountId){
      return (<span>Experience: {item.fromName}</span>)
    } 

    return (<span></span>)
  }

  renderAmountCell(item){
    if(item.fromAccountId === this.props.accountId){
      return (<span>(<MoneyDisplay>{item.amount}</MoneyDisplay>)</span>)
    } else {
      return (<span><MoneyDisplay>{item.amount}</MoneyDisplay></span>)
    }
  }

  getAmount(item){
    if(item.fromAccountId === this.props.accountId){
      return -1 * item.amount;
    } else {
      return 1 * item.amount;
    }    
  }

  render(){
    const { balance, transfers } = this.props;

    return (
      <div className='AccountTransferHistory'>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={transfers}
              hideSearch
              emptyText='No transfer history'
              columns={[
                {
                  name:'event',
                  width:30,
                  renderCell:(item) => this.renderEventCell(item)
                },
                {
                  name:'description',
                  width:40,
                  renderCell:(item) => this.renderDescriptionCell(item)
                },
                {
                  name:'date',
                  width:15,
                  sortFunc:(a,b) => a.lastModifiedDate - b.lastModifiedDate,
                  renderCell:(item) => <span>{moment(item.lastModifiedDate).format('MMM D, YYYY')}</span>
                },
                {
                  name:'amount',
                  width:15,
                  sortFunc:(a,b) => this.getAmount(a) - this.getAmount(b),
                  renderCell:(item) =>  this.renderAmountCell(item)
                }
              ]}
            />
            <div className='pull-right'>
              <br />
              <h5>Current Balance: <strong><MoneyDisplay>{balance}</MoneyDisplay></strong>&nbsp;&nbsp;&nbsp;</h5>
            </div>
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    );
  }
}

AccountTransferHistory.propTypes = {
  //TODO: Fill in prop types for AccountTransferHistory
};

AccountTransferHistory.defaultProps = {
  //TODO: Fill in defaultProps for AccountTransferHistory
};

export default AccountTransferHistory;



// WEBPACK FOOTER //
// ./src/routes/AccountTransferHistory/components/AccountTransferHistory.js